import { z } from "zod";
// The Home trends (CHT-2025): `GET /staff/home-trends`, in `apps/api/src/routes/staff-home-trends-routes.ts`. The admin calls it only
// through `@lafayette/api-client` (`staff-home-trends.ts`).
//
// STAFF ONLY and closed. The answer holds NUMBERS only: no customer, no request, no name, no text. One tile per question the caller's
// role may ask (a tile that the role may not read is not listed). A daily series always has 7 numbers, the oldest day first and today
// last. A tile that could not be read is `unavailable` and holds no number: the screen must say so and must never draw a zero.
const count = z.number().int().min(0).max(1_000_000);
/** Seven daily numbers, the oldest day first, today last. */
const daily = z.array(count).length(7);
export const staffHomeTrendKeyValues = [
    "open_requests",
    "places_to_review",
    "privacy_requests",
];
/**
 * Requests that are submitted and not ended. `team`: every request (a supervisor). `mine`: the requests the caller owns or is designated
 * for now; the past of that set is not known, so `previous` and `series` are `null` and the screen draws no trend.
 */
export const staffOpenRequestsTileSchema = z.strictObject({
    key: z.literal("open_requests"),
    status: z.literal("ok"),
    scope: z.enum(["team", "mine"]),
    current: count,
    /** The number 7 days ago, at the same time of day. */
    previous: count.nullable(),
    /** The number at the same time of day, for the last 7 days. */
    series: daily.nullable(),
    /** Open requests whose needed-by time falls on today (UTC). */
    dueToday: count,
});
/** Rows of an import that wait for a person to look at them (a warning or a possible duplicate). `series`: rows read per day. */
export const staffPlacesToReviewTileSchema = z.strictObject({
    key: z.literal("places_to_review"),
    status: z.literal("ok"),
    current: count,
    series: daily,
});
/** Privacy requests that are not final. `oldest` is the one that has waited longest: its kind, and the day it is on against the target. */
export const staffPrivacyTileSchema = z.strictObject({
    key: z.literal("privacy_requests"),
    status: z.literal("ok"),
    current: count,
    oldest: z
        .strictObject({
        kind: z.enum(["EXPORT", "DELETE"]),
        /** 1 on the day the request was made. */
        openDays: z.number().int().min(1).max(100_000),
        deadlineDays: z.number().int().min(1).max(365),
    })
        .nullable(),
});
export const staffHomeTrendUnavailableSchema = z.strictObject({
    key: z.enum(staffHomeTrendKeyValues),
    status: z.literal("unavailable"),
});
export const staffHomeTrendTileSchema = z.union([
    staffOpenRequestsTileSchema,
    staffPlacesToReviewTileSchema,
    staffPrivacyTileSchema,
    staffHomeTrendUnavailableSchema,
]);
export const staffHomeTrendsSchema = z.strictObject({
    generatedAt: z.iso.datetime({ offset: false }),
    tiles: z.array(staffHomeTrendTileSchema).max(8),
});
